import { cva } from 'class-variance-authority';

export const sfMarkStyles = cva('relative font-canela font-light leading-none', {
  variants: {
    size: {
      large: 'h-6.5 w-6.25 text-[22px] tracking-[3.96px]',
      small: 'flex items-start text-base',
    },
    color: {
      white: 'text-white',
      blue: 'text-blue-300',
    },
  },
  defaultVariants: {
    size: 'large',
    color: 'white',
  },
});
